module.exports = __webpack_public_path__ + "static/media/With-sound.9336d0b2.svg";